const {
	REACT_APP_COGNITO_USER_POOL_ID: COGNITO_USER_POOL_ID,
	REACT_APP_COGNITO_CLIENT_ID: COGNITO_CLIENT_ID,
	REACT_APP_COGNITO_DOMAIN: COGNITO_DOMAIN,
	REACT_APP_COGNITO_IDENTITY_POOL_ID: COGNITO_IDENTITY_POOL_ID,
	REACT_APP_OIDC_REDIRECT_URI: COGNITO_REDIRECT_URI,
	REACT_APP_ASSET_BUCKET: ASSET_BUCKET
} = process.env;

const awsExports = {
	'Auth': {
		identityPoolId: COGNITO_IDENTITY_POOL_ID,
		'region': 'eu-west-2',
		userPoolId: COGNITO_USER_POOL_ID,
		userPoolWebClientId: COGNITO_CLIENT_ID,
    oauth: {
      domain: COGNITO_DOMAIN,
      scope: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile', 'phone'],
      redirectSignIn: COGNITO_REDIRECT_URI,
      redirectSignOut: `${COGNITO_REDIRECT_URI}logout`,
      responseType: 'code'
    }
	},
	'Storage': {
		'AWSS3': {
			bucket: ASSET_BUCKET, //REQUIRED -  Amazon S3 bucket name
			region: 'eu-west-2'
		}
	}
};

export default awsExports;